import { Translation } from '@ps/web-shared-components';
import React from 'react';

import type { DepositContext, DepositResult } from '../../../../../../types/Cashier';
import { CardType } from '../../../../../../types/cardType';
import Info from '../../../Info/Info';
import MBWayRedirect from '../MBWayRedirect/MBWayRedirect';

import {
  TXTWCL_This_usually_takes_up_to_30_mi_ELL,
  TXTWCL_WeXll_send_you_an_email_update_ELL
} from './PartiallyCompletedCheck.messages.json';

type Props = DepositContext & DepositResult;

const PartiallyCompletedCheck: React.FC<Props> = ({ deposit, message }) => {
  const { defaultMessage: systemMsg } = message || { defaultMessage: '' };

  if (deposit.type === CardType.MBWay) {
    return <MBWayRedirect />;
  }

  return (
    <Info>
      {systemMsg === '' ? (
        <>
          <Translation {...TXTWCL_This_usually_takes_up_to_30_mi_ELL} />{' '}
          <Translation {...TXTWCL_WeXll_send_you_an_email_update_ELL} />
        </>
      ) : (
        systemMsg
      )}
    </Info>
  );
};

export default PartiallyCompletedCheck;
